








































































import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { casePriority } from '@/modules/Newcase/helpers/case'
import { Case } from '@/modules/Newcase/interfaces/case'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'

import CaseDialog from '@/modules/Newcase/scripts/case-dialog'
import { updateCaseStep } from '@/modules/Newcase/gql/case.gql'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'

import dollarFilter from '@/utils/dollarFilter'
import AccountAssets from '@/modules/Newcase/components/AccountAssets.vue'
import AccountCertificates from '@/modules/Newcase/components/AccountCertificates.vue'
import CaseAttachmentsCard from '../components/CaseAttachmentCard.vue'
import AccountInfo from '@/modules/Newcase/components/AccountInfo.vue'
import CasePanel from '@/modules/Newcase/components/CasePanel.vue'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import CasePolicyInfo from '../components/CasePolicyInfo.vue'
import CasePolicyDocusign from '../components/CasePolicyDocusign.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import { ApolloResponse } from '../../../interfaces/apollo'
import { getCaseReviews, reviewCaseStep } from '../gql/case.gql'

@Component({
  components: {
    CaseFoldingCard,
    AccountAssets,
    AccountCertificates,
    CaseAttachmentsCard,
    AccountInfo,
    CasePanel,
    CasePolicyInfo,
    CasePolicyDocusign,
    AppCheckbox
  }
})
export default class CaseDetailCompleted extends mixins(CaseDialog, PolicyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  completeDialog = {
    show: false
  }

  completeDisable = true

  reviews = {
    policy: false,
    files: false,
    asset: false,
    certificates: false,
    docusign: false
  }

  reviewers = {
    policy: undefined,
    files: undefined,
    asset: undefined,
    certificates: undefined,
    docusign: undefined
  }

  dollarFilter = dollarFilter
  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow
  casePriority = casePriority

  get attachmentList () {
    if (!this.caseInfo) {
      return []
    }
    return this.caseInfo.account.attachments || []
  }

  get policy () {
    return this.caseInfo.policies[this.caseInfo.policies.length - 1]
  }

  mounted () {
    this.getReviews()
  }

  @Watch('reviews', { deep: true })
  onReviewsChanged (val: any) {
    let canComplete = true
    for (const key in val) {
      if (val[key]) {
        continue
      }

      canComplete = false
      break
    }

    this.completeDisable = !canComplete
  }

  toNextStep () {
    this.completeDialog.show = true
  }

  async getReviews () {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCaseReviews,
        variables: {
          caseId: Number(this.$route.params.id)
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const res = result.data.getCaseReviews

      const reviews = {
        policy: false,
        files: false,
        asset: false,
        certificates: false,
        docusign: false
      }
      const reviewers = {
        policy: undefined,
        files: undefined,
        asset: undefined,
        certificates: undefined,
        docusign: undefined
      }

      for (const review of res) {
        switch (review.step) {
          case 0:
            reviewers.policy = review
            reviews.policy = true
            break
          case 1:
            reviewers.files = review
            reviews.files = true
            break
          case 2:
            reviewers.asset = review
            reviews.asset = true
            break
          case 3:
            reviewers.certificates = review
            reviews.certificates = true
            break
          case 4:
            reviewers.docusign = review
            reviews.docusign = true
            break
        }
      }

      this.reviewers = reviewers
      this.reviews = reviews
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async completeStepConfirm () {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.mutate({
        mutation: updateCaseStep,
        variables: {
          caseId: Number(this.caseInfo.id),
          step: this.caseInfo.step + 1
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.completeDialog.show = false
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  toPreviousStep () {

  }

  async reviewStep (step: number) {
    try {
      const result = await this.$apollo.mutate({
        mutation: reviewCaseStep,
        variables: {
          caseId: Number(this.$route.params.id),
          step
        }
      })

      const res = result.data.reviewCaseStep
    } catch (e) {
      showErrors(e.graphQLErrors)
    }

    return this.getReviews()
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  @Emit('assetCreate')
  onAssetCreate () {
    this.onSuccess()
  }
}
